import logo from "../../../../public/projects/Gera/logo/logo.png";
import evergreen from "../../../../public/projects/Godrej/images/projects/ev.jpg";
import island from "../../../../public/projects/Gera/projects/islandofjoy.webp";
import tree from "../../../../public/projects/Gera/projects/tree.webp";

// Gera- Island Of Joy
import overviewImage_islandofjoy from "../../../../public/projects/Gera/images/island_of_joy/Overview/1.webp";
import bannerDesktopImage_islandofjoy from "../../../../public/projects/Gera/images/island_of_joy/Banner/1.webp";
import bannerMobileImage_islandofjoy from "../../../../public/projects/Gera/images/island_of_joy/Banner/2.webp";
import siteVisitBannerImage_islandofjoy from "../../../../public/projects/Gera/images/island_of_joy/SiteVisitBanner/1.webp";
import Location_islandofjoy from "../../../../public/projects/Gera/images/island_of_joy/Location/L1.webp";
import Hightlights_islandofjoy from "../../../../public/projects/Gera/images/island_of_joy/Highlights/1.webp";
import floorplan1_islandofjoy from "../../../../public/projects/Gera/images/island_of_joy/floorplan/1.webp";
import floorplan2_islandofjoy from "../../../../public/projects/Gera/images/island_of_joy/floorplan/2.webp";
import floorplan3_islandofjoy from "../../../../public/projects/Gera/images/island_of_joy/floorplan/3.webp";
import floorplan4_islandofjoy from "../../../../public/projects/Gera/images/island_of_joy/floorplan/4.webp";
import locationicon_islandofjoy from "../../../../public/projects/Gera/images/island_of_joy/Overview/l.png";
import calicon_islandofjoy from "../../../../public/projects/Gera/images/island_of_joy/Overview/c.png";
import newlaunchicon_islandofjoy from "../../../../public/projects/Gera/images/island_of_joy/Overview/n.png";
import Gallery1_islandofjoy from "../../../../public/projects/Gera/images/island_of_joy/Gallery/1.webp";
import Gallery2_islandofjoy from "../../../../public/projects/Gera/images/island_of_joy/Gallery/2.webp";
import Gallery3_islandofjoy from "../../../../public/projects/Gera/images/island_of_joy/Gallery/3.webp";
import Gallery4_islandofjoy from "../../../../public/projects/Gera/images/island_of_joy/Gallery/4.webp";
import Gallery5_islandofjoy from "../../../../public/projects/Gera/images/island_of_joy/Gallery/5.webp";

// Gera - Joy Of Treetops
import overviewImage_joyoftreetops from "../../../../public/projects/Gera/images/joy_of_treetops/Overview/1.webp";
import bannerDesktopImage_joyoftreetops from "../../../../public/projects/Gera/images/joy_of_treetops/Banner/1.webp";
import bannerMobileImage_joyoftreetops from "../../../../public/projects/Gera/images/joy_of_treetops/Banner/2.webp";
import siteVisitBannerImage_joyoftreetops from "../../../../public/projects/Gera/images/joy_of_treetops/SiteVisitBanner/1.webp";
import Location_joyoftreetops from "../../../../public/projects/Gera/images/joy_of_treetops/Location/L1.webp";
import Hightlights_joyoftreetops from "../../../../public/projects/Gera/images/joy_of_treetops/Highlights/1.webp";
import floorplan1_joyoftreetops from "../../../../public/projects/Gera/images/joy_of_treetops/floorplan/1.webp";
import floorplan2_joyoftreetops from "../../../../public/projects/Gera/images/joy_of_treetops/floorplan/2.webp";
import floorplan3_joyoftreetops from "../../../../public/projects/Gera/images/joy_of_treetops/floorplan/3.webp";
import floorplan4_joyoftreetops from "../../../../public/projects/Gera/images/joy_of_treetops/floorplan/4.webp";
import gallery1_joyoftreetops from "../../../../public/projects/Gera/images/joy_of_treetops/Gallery/1.webp";
import gallery2_joyoftreetops from "../../../../public/projects/Gera/images/joy_of_treetops/Gallery/2.webp";
import gallery3_joyoftreetops from "../../../../public/projects/Gera/images/joy_of_treetops/Gallery/3.webp";
import gallery4_joyoftreetops from "../../../../public/projects/Gera/images/joy_of_treetops/Gallery/4.webp";
import gallery5_joyoftreetops from "../../../../public/projects/Gera/images/joy_of_treetops/Gallery/5.webp";
import locationicon_joyoftreetops from "../../../../public/projects/Gera/images/joy_of_treetops/Overview/l.png";
import calicon_joyoftreetops from "../../../../public/projects/Gera/images/joy_of_treetops/Overview/c.png";
import newlaunchicon_joyoftreetops from "../../../../public/projects/Gera/images/joy_of_treetops/Overview/n.png";
export const developerGera = {
  properties: [
    {
      name: "Gera Island of Joy",
      image: island,
      price: "On Request",
      state: "Pune",
      developer: "Gera",
      projectlocation: "East Pune",
      location: "Kharadi, Pune",
      bed: "1 - 2 - 3 - 4 BHK ",
      size: "....",
      url: `/gera-island-joy-kharadi-pune`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", 
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
    {
      name: "Gera Joy on the Treetops",
      image: tree,
      price: "83 lakh",
      state: "Pune",
      developer: "Gera",
      location: "Hinjawadi, Pune",
      projectlocation: "West Pune",
      bed: "2- 3 BHK Apartments",
      size: "753-1218 Sq. ft.",
      url: `/gera-joy-tree-tops-hinjewadi-pune`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
  ],
};
export const Headers = {
  logo: logo,
  data: {
    experience: "1970",
  },
  about: `With its landmark projects in Pune, Goa, and Bangalore, Gera Developments, which was founded in 1970, is a developer of high-end residential and commercial projects. It has introduced several firsts in the Indian real estate market, such as a child-centric project and an intelligent building.
`,
};

export const projectsGera = {
  geraislandofjoy: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_islandofjoy,
      bannerMobileImage: bannerMobileImage_islandofjoy,
      textOverlay: "",
      data: {
        title: "Gera's Island Of Joy",
        subtitle: "Kharadi, Pune",
        starting_price: "On Request",
        payment_plan: "CLP",
        rerano: "P52100052259",
        status: "Under Construction",
      },
    },
    overview: {
      heading: "Discover Luxury Living at Gera Island Of Joy",
      description: [
        "Gera Island of Joy, a child-centric township in East Kharadi, Pune, offers thoughtfully designed 2, 3, 3.5, and 4 BHK apartments with spacious decks, along with 3 BHK duplexes featuring expansive layouts. Each home includes a modular kitchen, blending style and functionality. With luxurious amenities and elegant architecture, it provides a serene retreat for your family.",
        "At its core, the CCH philosophy nurtures children's potential through nine celebrity-led learning academies. Gera’s commitment to holistic growth ensures a safe and inspiring environment where children can explore their passions and thrive, making it the perfect place to call home.",
      ],
      image: overviewImage_islandofjoy,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationicon_islandofjoy,
          title: "On Request ",
          subtitle: "Starting Price",
        },
        {
          iconClass: calicon_islandofjoy,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchicon_islandofjoy,
          title: "Under Construction",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_islandofjoy,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "2 BHK ",
          area: "676 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
        {
          type: "3 BHK ",
          area: "931 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
        {
          type: "3.5 BHK ",
          area: "1330 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK",
          area: "1830 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "2 BHK ",
        area: "676 sq. ft.",
        price: "On Request*",
        image: floorplan1_islandofjoy,
      },
      {
        type: "3 BHK ",
        area: "931 sq. ft.",
        price: "On Request*",
        image: floorplan2_islandofjoy,
      },
      {
        type: "3.5 BHK ",
        area: "1330 sq. ft.",
        price: "On Request*",
        image: floorplan3_islandofjoy,
      },
      {
        type: "4 BHK",
        area: "1830 sq. ft.",
        price: "On Request*",
        image: floorplan4_islandofjoy,
      },
    ],

    highlights: {
      images: Hightlights_islandofjoy,
      tagline: "Highlights",
      features: [
        "First-Ever Private Go-Kart Racing Track.",
        "60% Open Space in the project.",
        "An exclusive 3 Clubhouse spread across 39,000 sq. ft.",
        "Panoramic views of the River and garden.",
        "Vicinity to Commercial and IT hub .",
      ],
    },

    location: {
      image: Location_islandofjoy,
      data:[
        {
          airport:{
            distance_time:"11 km",
            name:"Pune Airport"
          },
          school:{
            distance_time:"3 Km",
            name:"HAC School"
          },
          railwayormetro:{
            distance_time:"13 Km",
            name:"Pune Junction"
          },
          hospital:{
            distance_time:"6 Km",
            name:" Manipal Hospital"
          },
          mall:{
            distance_time:"8 Km",
            name:"Amanora  Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: Gallery1_islandofjoy },
        { image: Gallery2_islandofjoy },
        { image: Gallery3_islandofjoy },
        { image: Gallery4_islandofjoy },
        { image: Gallery5_islandofjoy },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Gera Island Of Joy, kindly share more details.",
    },

    faq: [
      
      {
        question: "Where is Geras Island of Joy located?",
        answer: `The project is situated in Kharadi, Pune, a prime real estate hub known for its IT parks, excellent connectivity, and modern infrastructure.`,
      },
      {
        question: "What types of residences are available in Geras Island of Joy?",
        answer: `The project offers 2 BHK, 3 BHK, and 4 BHK apartments designed for modern living with premium interiors and smart home features.`,
      },
      {
        question: "What are the key amenities at Geras Island of Joy?",
        answer: `The project includes a swimming pool, clubhouse, landscaped gardens, kids’ play area, fitness center, jogging track, and 24/7 security.`,
      },
      {
        question: "Is Geras Island of Joy RERA registered?",
        answer: `Yes, the project is RERA registered, ensuring transparency and adherence to legal guidelines.`,
      },
      {
        question: "What makes Kharadi a good location for investment?",
        answer: `Kharadi is home to IT hubs like EON IT Park, top schools, hospitals, shopping malls, and excellent connectivity to Pune Airport and railway station, making it a prime investment choice. `,
      },
      {
        question: "What is the price range of apartments in Geras Island of Joy?",
        answer: `The price varies depending on the unit size and configuration. Contact the developer or real estate consultants for the latest pricing details.`,
      },
      {
        question: "What makes Geras Island of Joy a standout choice for homebuyers?",
        answer: `Gera's Island of Joy in East Kharadi, Pune, stands out as a premier choice for homebuyers seeking a blend of luxury, innovation, and family-centric living. `,
      },
      {
        question: "Who is the developer of Geras Island of Joy?",
        answer: `The project is developed by Gera Developments, a reputed name in the real estate sector known for its innovative and high-quality projects.`,
      },
      {
        question: "What is the possession date of Geras Island of Joy?",
        answer: `The estimated possession date depends on the phase of the project. It's best to check with the developer for exact timelines.`,
      },
      {
        question: "Are there any special features in this project?",
        answer: `Yes, it features resort-style living, themed landscapes, interactive spaces, and child-centric facilities, making it a unique residential destination.`,
      },
    ],
    similar: {
      properties: [
        {
          name: "Gera Island of Joy",
          image: island,
          price: "On Request",
          state: "Pune",
          developer: "Gera",
          projectlocation: "East Pune",
          location: "Kharadi, Pune",
          bed: "1 - 2 - 3 - 4 BHK ",
          size: "....",
          url: `/gera-island-joy-kharadi-pune`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", 
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "Gera Joy on the Treetops",
          image: tree,
          price: "83 lakh",
          state: "Pune",
          developer: "Gera",
          location: "Hinjawadi, Pune",
          projectlocation: "West Pune",
          bed: "2- 3 BHK Apartments",
          size: "753-1218 Sq. ft.",
          url: `/gera-joy-tree-tops-hinjewadi-pune`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
       api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
       source_id: 11,
       sub_source_id: 130,
       builder_id: `103`,
       project_id: `477`,
       subject: "Property Station enquiry", // Add or update the subject here
       to_email: "leads@gurugram-property.com",
     },
  },
  gerajoyoftreetops: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_joyoftreetops,
      bannerMobileImage: bannerMobileImage_joyoftreetops,
      textOverlay: "",
      data: {
        title: "Gera's Joy Of Tree-Tops",
        subtitle: "Hinjawadi, Pune",
        starting_price: "On Request",
        payment_plan: "CLP",
        rerano: "P52100077635",
        status: "Under Construction",
      },
    },
    overview: {
      heading: "Discover Luxury Living at Gera Joy Of Tree-Tops",
      description: [
        "Gera’s Joy on the Tree Tops, Hinjawadi’s first-ever ChildCentric® Homes (CCH), redefines family living with luxury and innovation. Spanning 10.7 acres, this exclusive township boasts a 35,000+ sq. ft. clubhouse and elegantly designed apartments with premium amenities. Thoughtfully crafted for comfort and style, each home offers a serene escape for your family.",
        " At its core, the CCH philosophy nurtures children’s potential through nine celebrity-led learning academies. Gera’s commitment to holistic development creates a safe, inspiring environment where kids can explore their passions and grow, making it the perfect place for families to thrive.",
      ],
      image: overviewImage_joyoftreetops,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationicon_joyoftreetops,
          title: "On Request ",
          subtitle: "Starting Price",
        },
        {
          iconClass: calicon_joyoftreetops,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchicon_joyoftreetops,
          title: "Under Construction",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_joyoftreetops,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "2 BHK ",
          area: "850 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
        {
          type: "2 BHK Duplex ",
          area: "895 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
        {
          type: "3 BHK ",
          area: "1210 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
        {
          type: "3 BHK Duplex",
          area: "1215 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "2 BHK ",
        area: "850 sq. ft.",
        price: "On Request*",
        image: floorplan1_joyoftreetops,
      },
      {
        type: "2 BHK Duplex ",
        area: "895 sq. ft.",
        price: "On Request*",
        image: floorplan2_joyoftreetops,
      },
      {
        type: "3 BHK ",
        area: "1210 sq. ft.",
        price: "On Request*",
        image: floorplan3_joyoftreetops,
      },
      {
        type: "3 BHK Duplex",
        area: "1215 sq. ft.",
        price: "On Request*",
        image: floorplan4_joyoftreetops,
      },
    ],

    highlights: {
      images: Hightlights_joyoftreetops,
      tagline: "Highlights",
      features: [
        "Spanning 32,000 sq. ft. this world-class racing arena promises",
        "Upcoming metro station in Hinjawadi Phase 3,It offers stunning, unobstructed views of scenic hills.",
        "It offers stunning, unobstructed views of scenic hills, ensuring superior air quality and a peaceful living environment.",
        "The development includes over1,700 apartments and duplexes across multiple phases.",
        "Pune’s first-ever Go Kart racing track.",
      ],
    },

    location: {
      image: Location_joyoftreetops,
      data:[
        {
          airport:{
            distance_time:"31 km",
            name:"Pune Airport"
          },
          school:{
            distance_time:"1.5 Km",
            name:"P . P School"
          },
          railwayormetro:{
            distance_time:"17 Km",
            name:"Akurdi Station"
          },
          hospital:{
            distance_time:"1.7 Km",
            name:" Vedanta Hospital"
          },
          mall:{
            distance_time:"8.5 Km",
            name:"Grand Highstreet"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1_joyoftreetops },
        { image: gallery2_joyoftreetops },
        { image: gallery3_joyoftreetops },
        { image: gallery4_joyoftreetops },
        { image: gallery5_joyoftreetops },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Gera Joy Of Tree-Tops, kindly share more details.",
    },

    faq: [
      {
        question: "What types of homes are available at Gera's Joy on the Tree Tops?",
        answer: `The project offers well-designed 2 and 3 BHK simplex and duplex homes.`,
      },
      {
        question: "What is the size of the development?",
        answer: `The project spans Over a 10.7-acre land.`,
      },
      {
        question: "How many towers and floors does the project have?",
        answer: `There are 7 elegant towers, each comprising 33 floors.`,
      },
      {
        question: "What is the starting price for the apartments?",
        answer: `Prices start at ₹81.90 lakh for a 2 BHK Grand apartment.`,
      },
      {
        question: "What makes Gera’s Joy on the Tree Tops a standout choice for homebuyers?",
        answer: `Gera’s Joy on the Tree Tops is a standout choice for homebuyers due to its unique forest-themed living experience, premium design, and focus on luxury and wellness.`,
      },
      {
        question: "What unique amenities are offered for children??",
        answer: `The project features ChildCentric Academies with world-class amenities, including academies by Shankar Mahadevan, Shiamak Davar, Michael Phelps, Rohit Sharma, and Pullela Gopichand.`,
      },
      {
        question: "Is there a go-karting facility available?",
        answer: `Yes, it's the first residential project in the area to offer go-karting amenities.`,
      },
      {
        question: "What smart home features are included?",
        answer: `Homes come equipped with smart home automation systems.`,
      },
      {
        question: "Is there a warranty provided for the homes?",
        answer: `Yes, the project offers India's first 7-year warranty on homes.`,
      },
      {
        question: "Are there any special offers for early bookings?",
        answer: `Spot booking offers up to ₹ 10 lakh are available.`,
      },
      {
        question: "What are the available floor plans?",
        answer: `The project offers various configurations, including 2 BHK - 850 sq. ft., 3 BHK - 1210 sq. ft.`,
      },
    ],
    similar: {
      properties: [
        {
          name: "Gera Island of Joy",
          image: island,
          price: "On Request",
          state: "Pune",
          developer: "Gera",
          projectlocation: "East Pune",
          location: "Kharadi, Pune",
          bed: "1 - 2 - 3 - 4 BHK ",
          size: "....",
          url: `/gera-island-joy-kharadi-pune`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", 
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "Gera Joy on the Treetops",
          image: tree,
          price: "83 lakh",
          state: "Pune",
          developer: "Gera",
          location: "Hinjawadi, Pune",
          projectlocation: "West Pune",
          bed: "2- 3 BHK Apartments",
          size: "753-1218 Sq. ft.",
          url: `/gera-joy-tree-tops-hinjewadi-pune`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
       api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
       source_id: 11,
       sub_source_id: 130,
       builder_id: `103`,
       project_id: `477`,
       subject: "Property Station enquiry", // Add or update the subject here
       to_email: "leads@gurugram-property.com",
     },
  },
};
